import { Splide } from '@splidejs/splide';

export default class Slider {
	constructor(selector = '.p-top-slider.splide') {
		this.selector = selector;
		this.sliderElement = document.querySelector(this.selector);
	}

	init() {
		if (!this.sliderElement) {
			return;
		}

		const splide = new Splide(this.sliderElement, {
			type: 'fade',
			rewind: true,
			speed: 1000,
			autoplay: true,
			interval: 5000,
			pauseOnHover: true,
			pagination: true,
			arrows: false,
		});

		splide.mount();
	}
}
